"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customFetch = void 0;
var http = require("http");
var common_1 = require("./common");
var processJson_1 = require("./processJson");
function customFetch(params) {
    var isBrowser = (0, common_1.checkBrowser)();
    return isBrowser
        ? customBrowserFetch(params)
        : customNodeFetch(params);
}
exports.customFetch = customFetch;
function customBrowserFetch(_a) {
    var method = _a.method, host = _a.host, path = _a.path, withCredentials = _a.withCredentials, headers = _a.headers, body = _a.body;
    return new Promise(function (resolve, reject) {
        var req = new XMLHttpRequest();
        req.ontimeout = function () {
            reject();
        };
        req.onerror = function () {
            reject();
        };
        req.onreadystatechange = function () {
            if (req.readyState !== 4) {
                return;
            }
            if (req.status !== 200) {
                reject((0, processJson_1.processJson)(req.responseText));
            }
            else {
                resolve((0, processJson_1.processJson)(req.responseText));
            }
        };
        req.open(method, "" + host + path, true);
        if (headers && headers.length) {
            headers.forEach(function (header) {
                req.setRequestHeader(header[0], header[1]);
            });
        }
        req.withCredentials = withCredentials || false;
        req.timeout = 10000;
        req.send(body);
    });
}
function customNodeFetch(_a) {
    var method = _a.method, host = _a.host, path = _a.path, headers = _a.headers, body = _a.body;
    return new Promise(function (resolve, reject) {
        var headersObject = headers === null || headers === void 0 ? void 0 : headers.reduce(function (result, _a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            result[key] = value;
            return result;
        }, {});
        var req = http.request({
            hostname: host,
            port: 80,
            method: method,
            path: path,
            headers: headersObject,
        }, function (response) {
            var str = '';
            response.on('data', function (chunk) {
                str += chunk;
            });
            response.on('end', function () {
                if (response.statusCode === 200) {
                    resolve({});
                }
                reject(str);
            });
        });
        req.write(body);
        req.end();
    });
}
//# sourceMappingURL=fetch.js.map